/**
 * Slugs dos tipos de managed device usados para trocar a renderização da lista.
 *
 * O slug vem do banco (`managed_device_type_definitions`). O tipo antigo `vm`
 * foi renomeado para `hosts` (migration RenameVmTypeToHosts) porque nunca foi só
 * VM — cobre host Linux/Windows em bare metal, VM ou notebook com Connect.IO.
 *
 * O alias abaixo mantém URLs antigas (`/managed-devices?type=vm`) e ambientes
 * onde a migration ainda não rodou funcionando sem mudança de código.
 */
export const HOSTS_TYPE_SLUG = 'hosts';

const SLUG_ALIASES = {
  vm: HOSTS_TYPE_SLUG,
};

/** Converte um slug legado no slug canônico atual. */
export function normalizeTypeSlug(slug) {
  if (!slug) return null;
  return SLUG_ALIASES[slug] || slug;
}

/** true quando o tipo (entidade da API) é a aba de hosts Linux/Windows. */
export function isHostsType(type) {
  return normalizeTypeSlug(type?.slug) === HOSTS_TYPE_SLUG;
}

/**
 * Aba "Mobile" — tablets/celulares Android gerenciados pelo MDM (agente Device
 * Owner). Tem lista e detalhe próprios (MobileFleet / MobileDeviceConsole).
 */
export const MOBILE_TYPE_SLUG = 'mobile';

/** true quando o tipo (entidade da API) é a aba Mobile (MDM). */
export function isMobileType(type) {
  return normalizeTypeSlug(type?.slug) === MOBILE_TYPE_SLUG;
}
